import Col from "@visa/vds/col";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import "flag-icon-css/css/flag-icon.min.css";
import React from "react";

const ContactType = (props) => {
  return (
    <>
      <div style={{marginBottom: "-30px"}}>
        <Row>
          <Typography tag="h3" style={{ marginLeft: "15px" }}>
            {props.contactType}
          </Typography>
        </Row>
        <Row>
          <Typography tag="h4" style={{ marginLeft: "15px" }}>
            {props.contactTypeDescription}
          </Typography>
        </Row>
        <Row>
          <Col>
            <Typography tag="h4" style={{ marginTop: "-10px", marginLeft: "3px" }}>
              <u>Key Contact 1</u>
            </Typography>
          </Col>
          <Col>
            <Typography tag="h4" style={{ marginTop: "-10px", marginLeft: "3px" }}>
              <u>Key Contact 2</u>
            </Typography>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ContactType;
